// import React, { useState, useEffect } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { Users, ShoppingCart, X } from 'lucide-react';

// const EVENTS = [
//   { type: 'enroll', name: 'Priya S.', course: 'Generative AI', time: '2 min ago', location: 'Mumbai' },
//   { type: 'purchase', name: 'Rahul K.', course: 'Full Stack Development', amount: 41999, time: 'Just now', location: 'Bangalore' },
//   { type: 'enroll', name: 'Sneha M.', course: 'Cyber Security (VAPT)', time: '5 min ago', location: 'Delhi' },
//   { type: 'purchase', name: 'Arjun T.', course: 'AI & Machine Learning', amount: 46999, time: '1 min ago', location: 'Hyderabad' },
//   { type: 'enroll', name: 'Ananya R.', course: 'Python Programming', time: '3 min ago', location: 'Chennai' },
//   { type: 'purchase', name: 'Vikram P.', course: 'Agentic AI', amount: 41999, time: 'Just now', location: 'Pune' },
//   { type: 'enroll', name: 'Kavya L.', course: 'ServiceNow', time: '4 min ago', location: 'Kolkata' },
//   { type: 'purchase', name: 'Rohan D.', course: 'SOC Security', amount: 37999, time: '2 min ago', location: 'Ahmedabad' },
// ];

// export default function ActivityPopup() {
//   const [currentEvent, setCurrentEvent] = useState(null);
//   const [visible, setVisible] = useState(false);
//   const [index, setIndex] = useState(0);
//   const [dismissed, setDismissed] = useState(false);

//   useEffect(() => {
//     if (dismissed) return;

//     // Show first popup after 4 seconds
//     const initialTimer = setTimeout(() => {
//       setCurrentEvent(EVENTS[0]);
//       setVisible(true);
//     }, 4000);

//     return () => clearTimeout(initialTimer);
//   }, [dismissed]);

//   useEffect(() => {
//     if (!visible || dismissed) return;

//     // Auto-hide after 5 seconds
//     const hideTimer = setTimeout(() => {
//       setVisible(false);
//     }, 5000);

//     // Show next popup 8 seconds after hide
//     const nextTimer = setTimeout(() => {
//       if (dismissed) return;
//       const nextIndex = (index + 1) % EVENTS.length;
//       setIndex(nextIndex);
//       setCurrentEvent(EVENTS[nextIndex]);
//       setVisible(true);
//     }, 13000);

//     return () => {
//       clearTimeout(hideTimer);
//       clearTimeout(nextTimer);
//     };
//   }, [visible, index, dismissed]);

//   const handleDismiss = () => {
//     setVisible(false);
//     setDismissed(true);
//   };

//   if (!currentEvent) return null;

//   const isPurchase = currentEvent.type === 'purchase';

//   return (
//     <AnimatePresence>
//       {visible && (
//         <motion.div
//           initial={{ opacity: 0, x: -80, y: 20 }}
//           animate={{ opacity: 1, x: 0, y: 0 }}
//           exit={{ opacity: 0, x: -80, y: 20 }}
//           transition={{ type: 'spring', stiffness: 300, damping: 28 }}
//           className="fixed bottom-6 left-4 z-50 max-w-[300px]"
//         >
//           <div className="bg-white rounded-2xl shadow-2xl border border-slate-100 p-4 flex items-start gap-3 relative overflow-hidden">
//             {/* Accent strip */}
//             <div className={`absolute left-0 top-0 bottom-0 w-1 rounded-l-2xl ${isPurchase ? 'bg-gradient-to-b from-green-400 to-emerald-600' : 'bg-gradient-to-b from-primary to-violet-600'}`} />

//             {/* Icon */}
//             <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${isPurchase ? 'bg-green-50' : 'bg-primary/10'}`}>
//               {isPurchase
//                 ? <ShoppingCart className="w-5 h-5 text-green-600" />
//                 : <Users className="w-5 h-5 text-primary" />
//               }
//             </div>

//             {/* Content */}
//             <div className="flex-1 min-w-0">
//               <p className="text-slate-900 text-sm font-semibold leading-tight">
//                 {isPurchase
//                   ? `${currentEvent.name} purchased a course`
//                   : `${currentEvent.name} just enrolled`
//                 }
//               </p>
//               <p className="text-slate-500 text-xs mt-0.5 truncate">{currentEvent.course}</p>
//               {isPurchase && (
//                 <p className="text-green-600 text-xs font-bold mt-0.5">₹{currentEvent.amount.toLocaleString('en-IN')}</p>
//               )}
//               <div className="flex items-center gap-2 mt-1">
//                 <span className="text-slate-400 text-xs">{currentEvent.location}</span>
//                 <span className="text-slate-300 text-xs">·</span>
//                 <span className="text-slate-400 text-xs">{currentEvent.time}</span>
//               </div>
//             </div>

//             {/* Dismiss */}
//             <button onClick={handleDismiss} className="text-slate-300 hover:text-slate-500 transition-colors flex-shrink-0">
//               <X className="w-4 h-4" />
//             </button>

//             {/* Progress bar */}
//             <motion.div
//               className={`absolute bottom-0 left-0 h-0.5 ${isPurchase ? 'bg-green-400' : 'bg-primary'}`}
//               initial={{ width: '100%' }}
//               animate={{ width: '0%' }}
//               transition={{ duration: 5, ease: 'linear' }}
//             />
//           </div>
//         </motion.div>
//       )}
//     </AnimatePresence>
//   );
// }

const ActivityPopup = () => {
  return (
    <></>)}
    export default ActivityPopup;